<div class="modal-header">
    <h4 class="modal-title pull-left">Share Listings</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefShareListing.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body padding30">
    <div class="form-group">
        <label class="form-label">Email Address<span class="star">*</span></label>
        <div class="textbox-date">
            <tag-input [(ngModel)]="mailIds" secondaryPlaceholder="Email Address" placeholder="+ Email IDs" [errorMessages]="errorMessages" [validators]="validators" [separatorKeyCodes]="keyCode">
            </tag-input>
            <p class="redtext" *ngIf="mailIds.length == 0  && isShareSubmit">Email Address is required</p>
            <h5 class="infotext">
                Use a comma or space to separate multiple email addresses.
            </h5>
        </div>
    </div>  
    <div class="form-group">
        <label class="form-label">Description <span class="star">*</span></label>
        <input class="form-control" placeholder="Description" #GroupName="ngModel" maxlength="100" [(ngModel)]="shareListing.GroupName" required type="text">
        <p class="redtext" *ngIf="(Validation.IsinValid(shareListing.GroupName) && isShareSubmit) ||(GroupName.invalid && GroupName.touched)">Description is required</p>
    </div>
    <div class="form-group">
        <label class="form-label">
            Expiration Date
            <span class="star">*</span>
        </label>
        <div class="textbox-date">
            <input bsDatepicker #ExpiryDate="ngModel" class="form-control" type="text" [(ngModel)]="shareListing.ExpiryDate">
            <i class="icofont icofont-ui-calendar icon"></i>
            <div *ngIf="(Validation.IsinValid(shareListing.ExpiryDate) && isShareSubmit )||(ExpiryDate.invalid && ExpiryDate.touched)">
                <p class="redtext">
                    Expiration Date is required
                </p>
            </div>
        </div>
    </div>
    <div class="margin-bottom-15" style="max-height:300px;overflow-y:scroll" *ngIf="!isShareMode">
        <div class="modal-data-box" *ngFor="let property of sharedList;let i = index" style="margin-bottom:5px;margin-right:5px">
            <button type="button" class="close pull-right" aria-label="Close" style="color:black" (click)="removeProperty(property.PropertyId,i)">
                <span aria-hidden="true">&times;</span>
            </button>
            <h4 style="font-weight:600;">{{property.PropertyName}}</h4>
            <p>{{property.FullAddress}}</p>
            <span class="tag" [ngClass]="{'redtext':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),
                    'greentext':property.PropertyStatus === 'Available',
                    'gerytext':property.PropertyStatus === 'Under Contract','ashtext':property.PropertyStatus === 'Off-Market'}">
                {{property.PropertyStatus}}
            </span>
        </div>
    </div>
    <div class="nodata" *ngIf="sharedList.length == 0 && !isShareMode">
        <i class="fa fa-exclamation-triangle icon"></i>
        <p>No Property Selected</p>
    </div>
    <div class="text-right">
        <button class="btn btn-lg btn-default" (click)="modalRefShareListing.hide()">Cancel</button>
        <button class="btn btn-success btn-lg" [disabled]="sharedList.length == 0 && !isShareMode" (click)="shareList();">Share</button>
    </div>
</div>